import { render, staticRenderFns } from "./InscricaoGarante.vue?vue&type=template&id=fec89e52&"
import script from "./InscricaoGarante.vue?vue&type=script&lang=js&"
export * from "./InscricaoGarante.vue?vue&type=script&lang=js&"
import style0 from "./InscricaoGarante.vue?vue&type=style&index=0&id=fec89e52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports